import { colors, fonts } from 'theme'
import { fontSizes } from 'theme/fonts'
import css from 'styled-jsx/css'

export default css`
  .form-container {
    display: flex;
    flex-direction: column;
    height: auto;
    margin: 200px auto 0;
    max-width: 540px;
    width: 100%;
    text-align: left;
  }

  @media (max-width: 992px) {
    .form-container {
      margin-top: 0;
    }
  }

  h4 {
    font: ${fonts.semiBold};
    font-size: ${fontSizes.h4};
    text-align: left;
    color: ${colors.text};
    margin: 0px;
  }

  .legend {
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 14px;
    text-align: left;
    color: ${colors.lightText};
    margin: 10px auto 0px auto;
  }

  .terms {
    font: ${fonts.regular};
    font-size: 10px;
    text-align: center;
    max-width: 350px;
    margin-left: auto;
    margin-right: auto;
    color: ${colors.lightText};
  }

  .terms-link {
    color: ${colors.secondary};
  }

  .form-container :global(.actions) {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 1rem;
  }

  .form-container :global(.submit) {
    margin: 10px 0;
  }

  .action-switch {
    margin-bottom: 0px;
  }

  .switch-container {
    height: 100%;
    display: flex;
    justify-content: right;
    align-items: center;
  }
`
